'use client';

import { useState, useMemo } from 'react';
import { postContact } from '@src/apis/contact/post-contact';
import _ from "lodash"

// Context
import useGlobalCtx from '@src/context/global-ctx';
import ModalSuccess from "@src/components/century-21-or-company/modal-success"

const Divider = ({ className }) => <div className={`w-full h-[1px] my-4 border-b border-solid border-grey-0 ${className}`} />

const CInput = ({ label, ...props }) => {
  return (
    <div>
      <p className='ml-[12px] text-13 font-sfpro-semibold mb-1'>{label}</p>
      <input
        {...props}
        className='text-15 w-full text-black-1 placeholder:text-grey-6 py-[10px] px-4 rounded-[80px]'
      />
    </div>
  )
}

const CTextarea = ({ label, ...props }) => {
  return (
    <div className='mb-6'>
      <p className='ml-[12px] text-13 font-sfpro-semibold mb-1'>{label}</p>
      <textarea
        {...props}
        className='h-[88px] text-17 w-full text-black-1 placeholder:text-grey-6 py-[10px] px-4 rounded-2xl'
      />
    </div>
  )
}

const Form = () => {
  const { setShowLoader } = useGlobalCtx()

  const [isOpenModalSuccess, setIsOpenModalSuccess] = useState(false)
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: ""
  })

  const handleSubmitContact = async () => {
    try {
      setShowLoader(true)
      await postContact(form)
      setForm({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
      })
      setShowLoader(false)
      setIsOpenModalSuccess(true)
    } catch (error) {
      console.log(error)
      setShowLoader(false)
    }
  }

  const handleChangePhone = (e) => {
    const newValue = e.target.value.replace(/\D/g, '');
    const name = e.target.name;

    let newForm = { ...form };
    newForm[name] = newValue

    setForm(newForm);
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    const name = e.target.name;

    let newForm = { ...form };
    newForm[name] = newValue

    setForm(newForm);
  };

  const isDisableForm = useMemo(() => _.every(form, _.isEmpty), [form])

  return (
    <div className='h-fit rounded-2xl border-[0.5px] border-solid border-grey-0 bg-white-4 py-4 px-8 
    dd-xl:!p-2'>
      <CInput
        onChange={handleChange}
        name="name"
        label="Name"
        placeholder="Masukan Nama Anda"
        value={form["name"]}
      />
      <Divider />
      <CInput
        onChange={handleChange}
        name="email"
        label="Alamat email"
        placeholder="Contoh: century21ina@gmail.com"
        value={form["email"]}
      />
      <Divider />
      <div className='grid grid-cols-2 gap-x-4 
      dd-xl:block'>
        <CInput
          onChange={handleChange}
          name="subject"
          label="Subject"
          placeholder="Masukkan subject"
          value={form["subject"]}
        />
        <Divider className="hidden dd-xl:block" />
        <CInput
          onChange={handleChangePhone}
          name="phone"
          label="Nomor Telepon"
          placeholder="Masukkan nomor telepon"
          value={form["phone"]}
        />
      </div>
      <Divider />
      <CTextarea
        onChange={handleChange}
        name="message"
        label="Pesan"
        placeholder="Apa yang ingin disampaikan?"
        value={form["message"]}
      />

      <div className='flex justify-center'>
        <button disabled={isDisableForm} onClick={handleSubmitContact} className='py-[14px] px-[18px] rounded-[80px] bg-yellow-0 text-15 font-sfpro-heavy 
        dd-xl:w-full'>KIRIM PESAN</button>
      </div>

      <ModalSuccess
        isOpen={isOpenModalSuccess}
        onClose={() => setIsOpenModalSuccess(false)}
        title="Pesan Terkirim!"
        description="Terima kasih telah menghubungi kami. Kami selalu berusaha memberikan pelayanan terbaik untuk Anda."
      />
    </div>
  )
}

export default Form